import { BitkitIconComponent } from '@bitrise/bitkit-v2';
import { Box, BoxProps } from '@chakra-ui/react/box';
import { Text, TextProps } from '@chakra-ui/react/text';
import { Children, forwardRef } from 'react';

type BuildMetaDataProps = {
  icon?: BitkitIconComponent;
  textProps?: TextProps;
  textColor?: BoxProps['color'];
} & BoxProps;
const BuildMetaData = forwardRef<HTMLDivElement, BuildMetaDataProps>(
  ({ icon: Icon, children, gap = '4', color, textColor, textProps, ...rest }, ref) => (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      gap={gap}
      color={color ?? textColor ?? 'text/primary'}
      ref={ref}
      {...rest}
    >
      {Icon && <Icon size="16" />}
      {children && (
        <>
          {Children.toArray(children).every((i) => typeof i === 'string' || typeof i === 'number') ? (
            <Text as="span" textStyle="body/md/regular" lineHeight="16px" {...textProps}>
              {children}
            </Text>
          ) : (
            children
          )}
        </>
      )}
    </Box>
  ),
);

BuildMetaData.displayName = 'BuildMetaData';

export default BuildMetaData;
